import { useEffect, type JSX } from 'react';
import { useChatbotConfig } from '../../ChatbotProvider';
import { useChatInputViewModel } from './chat-input.viewmodel';

const SendIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor' width='16' height='16'>
    <path d='M2.01 21L23 12 2.01 3 2 10l15 2-15 2z' />
  </svg>
);

type Props = {
  isDisabled: boolean;
  onSend: (text: string) => void;
};

export const ChatInput = ({ isDisabled, onSend }: Props): JSX.Element => {
  const config = useChatbotConfig();
  const [state, viewModel] = useChatInputViewModel(onSend, isDisabled);

  // Keep the viewmodel's isDisabled in sync with the prop
  useEffect(() => {
    viewModel.setDisabled(isDisabled);
  }, [isDisabled, viewModel]);

  const placeholder = isDisabled
    ? (config.inputDisabledPlaceholder ?? 'Even geduld...')
    : (config.inputPlaceholder ?? 'Typ een bericht...');

  return (
    <div className='chatbot-input-area'>
      <textarea
        className='chatbot-input-field'
        rows={2}
        placeholder={placeholder}
        disabled={isDisabled}
        value={state.text}
        onChange={(e) => viewModel.setText(e.target.value)}
        onKeyDown={viewModel.handleKeyDown}
      />
      <button
        className='chatbot-send-btn'
        disabled={viewModel.isSendDisabled()}
        onClick={viewModel.handleSend}
        aria-label={config.sendButtonAriaLabel ?? 'Verstuur bericht'}
      >
        <SendIcon />
        <span className='chatbot-send-btn-label'>{config.sendButtonLabel ?? 'Verstuur'}</span>
      </button>
    </div>
  );
};
